import * as types from "../../actions/modal/types";

const initialState = {
    type_modal: null,//"SUBMIT_TICKET",
    payload: null
};

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case types.LAUNCH_MODAL:
            return Object.assign({}, state, {
                type_modal: action.type_modal,
                payload: action.payload ? action.payload : null
            });
        default:
            return state;
    }
};
